<div class="app-footer">
    <a [href]="links.privacy" target="_blank">Privacy Policy</a>
    <span> Sigsense Technologies &copy; {{ year }} </span>
</div>
